import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, FormSection } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { lt, showErrorAlert } from '@mews/framework';
import { withBreakpointRange } from '@optimus-web/core';
import { WithBreakpointRange, isMobile } from '@mews-commander/ui';
import { mapValuesIndexed } from '@mews-commander/utils';
import { validation } from '@mews-commander/legacy-form';
import { getCountryOptions } from '@mews-commander/legacy-entities/src/ducks/countries';
import { getLanguageOptions } from '@mews-commander/legacy-entities/src/ducks/languages';
import { save, close, reset } from '../actions';
import { isFetching, getProfileAndDocumentValues } from '../selectors';
import { constraints as profileConstraints, ProfileCreationFormFields } from '../../customerProfile/components';
import {
    IdentityDocumentFormFields,
    getConstraints as getDocumentConstraints,
} from '../../identityDocuments/components/IdentityDocumentForm';
import { openCustomerDetail } from '../../app/actions/customer';
import { refreshPage } from '../../app/actions/common';
import { IDENTITY_FORM_SECTION, PROFILE_FORM_SECTION } from '../module';
import {
    EditorWrapper,
    ColumnsWrapper,
    Column,
    ButtonHolder,
    CancelButton,
    RightActionsWrapper,
    LeftActionsWrapper,
    ResetButton,
    SaveButton,
    MobileResetButton,
} from './style';

interface ValuesEditorProps extends WithBreakpointRange {
    isOpened?: boolean;
    loading?: boolean;
    handleClose?: $TSFixMeFunction;
    handleReset?: $TSFixMeFunction;
    handleSave?: $TSFixMeFunction;
    customerId?: string;
}
class ValuesEditor extends Component<ValuesEditorProps> {
    // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
    handleClose = () => this.props.handleClose();
    // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
    handleReset = () => this.props.handleReset();
    render() {
        const {
            isOpened,
            loading,
            customerId,
            breakpointRange,
            // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type 'Readonly<ValuesEditorProps> & Readonly<{ children?: ReactNode; }>'.
            scope,
            // @ts-expect-error $TSFixMeError: Property 'handleSubmit' does not exist on type 'Readonly<ValuesEditorProps> & Readonly<{ children?: ReactNode; }>'.
            handleSubmit,
            // omitted props
            // @ts-expect-error $TSFixMeError: Property 'onSuccess' does not exist on type 'Readonly<ValuesEditorProps> & Readonly<{ children?: ReactNode; }>'.
            onSuccess,
            handleClose,
            handleReset,
            handleSave,
            // @ts-expect-error $TSFixMeError: Property 'onEdit' does not exist on type 'Readonly<ValuesEditorProps> & Readonly<{ children?: ReactNode; }>'.
            onEdit,
            ...others
        } = this.props;
        const mobile = isMobile(breakpointRange);
        return (
            // @ts-expect-error $TSFixMeError: No overload matches this call.
            <EditorWrapper isOpened={isOpened}>
                {isOpened && (
                    // @ts-expect-error $TSFixMeError: No overload matches this call.
                    <ColumnsWrapper singleColumn={mobile}>
                        {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                        <Column singleColumn={mobile}>
                            <FormSection name={PROFILE_FORM_SECTION}>
                                {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                                <ProfileCreationFormFields scope={scope} {...others} isScanner />
                            </FormSection>
                        </Column>
                        {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                        <Column singleColumn={mobile}>
                            <FormSection name={IDENTITY_FORM_SECTION}>
                                {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                                <IdentityDocumentFormFields scope={scope} {...others} isScanner />
                            </FormSection>
                        </Column>
                    </ColumnsWrapper>
                )}
                <ButtonHolder>
                    <LeftActionsWrapper>
                        {mobile ? (
                            // @ts-expect-error $TSFixMeError: No overload matches this call.
                            <MobileResetButton onClick={this.handleReset} />
                        ) : (
                            <ResetButton onClick={this.handleReset} />
                        )}
                    </LeftActionsWrapper>
                    <RightActionsWrapper>
                        <CancelButton onClick={this.handleClose} />
                        <SaveButton onClick={handleSubmit} disabled={loading} />
                    </RightActionsWrapper>
                </ButtonHolder>
            </EditorWrapper>
        );
    }
}
const composedConstraints = {
    [IDENTITY_FORM_SECTION]: getDocumentConstraints({}),
    [PROFILE_FORM_SECTION]: profileConstraints,
};
const composedValidation = (constraints: $TSFixMe) =>
    // @ts-expect-error $TSFixMeError: Expected 2 arguments, but got 1.
    mapValuesIndexed((value: $TSFixMe, key: $TSFixMe) => validation(constraints[key])(value));
export default compose(
    withBreakpointRange,
    connect(
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        createStructuredSelector({
            loading: isFetching,
            initialValues: getProfileAndDocumentValues,
            countryOptions: getCountryOptions,
            languageOptions: getLanguageOptions,
        }),
        // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type 'BreakpointRangeHocState<B> & { children?: ReactNode; }'.
        (dispatch, { scope, customerId }) => ({
            onSubmitFail: () => showErrorAlert({ description: lt('ValidationErrorMessage') }),
            onSubmit: (formValues: $TSFixMe) =>
                // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
                (dispatch(save(customerId, formValues, scope)) as $TSFixMe).then(({ value: id }) => {
                    if (customerId) {
                        // @ts-expect-error $TSFixMeError: Argument of type 'ThunkAction<Action<any>, void, ApplicationState>' is not assignable to parameter of type 'Action<any>'...
                        dispatch(refreshPage());
                    } else {
                        // @ts-expect-error $TSFixMeError: Argument of type 'ThunkAction<Action<any>, void, ApplicationState>' is not assignable to parameter of type 'Action<any>'...
                        dispatch(openCustomerDetail(id));
                    }
                }),
            // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe) => void' is not assignable to parameter of type 'Action<any>'.
            handleClose: () => dispatch(close(scope)),
            handleReset: () => dispatch(reset(scope, customerId)),
        })
    ),
    reduxForm({
        enableReinitialize: true,
        validate: composedValidation(composedConstraints),
    })
)(ValuesEditor);
